module.exports = __webpack_public_path__ + "img/printer.922f4c9c.png";